import ClienteShow from './ClienteShow.vue'

export default ClienteShow
